import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Help from '../../Help/Help'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, NonLocalizableDom, handleToggleClick } from '../helper'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import GroupFieldTitleToggle from "../HelperComponents/GroupFieldTitleToggle"

const MultiLineText = (props: any) => {
  const {
    onChange,
    options,
    parentInfo,
    uniqueKey,
    schema,
    type,
    isNonLocalizable,
    hasNonLocalizablePlan,
    hasNonLocalizablePlanForBlocksAndGroupMultiple,
    isCTBuilder
  } = props

  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef.current.focus()
  }, [displayNameRef])

  const onchange = () => {
    console.log('Multi log')

    onChange && onChange(schema)
    setSchema({ ...schema })
  }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value
    //schema.uid = schema.display_name.trim().toLowerCase().replace(' ', '_');

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))
    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onPlaceholderChange = (event: any) => {
    field_metadata.placeholder = event.target.value
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onMinChange = (event: any) => {
    schema.min = parseInt(event.target.value) || null
    if (event.target.value.length && (schema.min < 0 || schema.min > schema.max)) {
      schema.error_details = {
        ...schema.error_details,
        min: 'minimum value cannot be zero or larger than max value'
      }
      schema.error = true
    } else {
      console.log('error_details are', schema.error_details)
      schema.error_details = {
        ...schema.error_details,
        min: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onMaxChange = (event: any) => {
    schema.max = parseInt(event.target.value) || null
    if (event.target.value.length && (schema.max < 0 || schema.max < schema.min)) {
      schema.error_details = {
        ...schema.error_details,
        max: 'max value cannot be lower than min value'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onValChnage = (event: any) => {
    schema.format = event.target.value
    onchange()
  }
  const onValErrChange = (event: any) => {
    if (schema.error_messages) {
      schema.error_messages.format = event.target.value
    } else {
      schema.error_messages = {
        format: event.target.value
      }
    }
    onchange()
  }
  const onDefaultValueChange = (event: any) => {
    field_metadata.default_value = event.target.value
    if (
      field_metadata.default_value.length
        ? field_metadata.default_value.length < schema.min || field_metadata.default_value.length > schema.max
        : false
    ) {
      schema.error_details = {
        ...schema.error_details,
        default_value: 'Default value length not satisfying min/max length'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        default_value: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.unique`) {
      schema.unique = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.multiple`) {
      if (event.target.checked) field_metadata.isTitle = false;
      schema.multiple = event.target.checked
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
      if (!schema.multiple) {
        delete schema.max_instance
      }
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }

  const onMaxInstance = (event: any) => {
    schema.max_instance = event.target.value ? parseInt(event.target.value) : null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && schema.max_instance < 0) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'max instance cannot be less then zero'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }

    onchange()
  }

  if (type === 'basic') {
    console.log('This is inside the multiLine check')
    return (
      <div className="FormFields">
        <div className="FormFields__column">
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-basic-display-label' version="v2" required htmlFor="displayName">
              Display Name
            </FieldLabel>
            <TextInput
              required
              version="v2"
              name={`${uniqueKey}.displayName`}
              value={display_name}
              onChange={onDisplayNameChange}
              inputRef={displayNameRef}
              error={schema.error && schema.error_details.display_name ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId='cs-ctf-mutlilinetext-basic-uid-label' version="v2" required htmlFor="uid">
              Unique ID
            </FieldLabel>
            <Help testId='cs-ctf-multilinetext-basic-uid-helptext' type="basic" text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
            <TextInput
              version="v2"
              required
              name={`${uniqueKey}.uid`}
              value={uid}
              onChange={onUidChange}
              error={(schema.error && schema.error_details.uid) || error ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-basic-placeholder-label' version="v2" htmlFor="placeholder">Placeholder Value</FieldLabel>
            <TextInput
              version="v2"
              name={`${uniqueKey}.placeholder`}
              value={field_metadata.placeholder || ''}
              onChange={onPlaceholderChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.PLACEHOLDER_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-basic-instruction-label' version="v2" htmlFor="instruction">Instruction Value</FieldLabel>
            <Help testId='cs-ctf-multilinetext-basic-instruction-helptext' type="basic" text="Helps you add instructions for this field. The instructional text will appear below the field." />
            <Textarea
              name={`${uniqueKey}.instruction`}
              version="v2"
              value={field_metadata.instruction || ''}
              onChange={onInstructionChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-basic-helptext-label' version="v2" htmlFor="helpText">Help Text</FieldLabel>
            <Help testId='cs-ctf-multilinetext-basic-helptext-helptext' type="basic" text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
            <Textarea
              name={`${uniqueKey}.helpText`}
              value={field_metadata.description || ''}
              onChange={onHelpTextChange}
              showCharacterCount={true}
              hideCharCountError={false}
              maxLength={256}
              version="v2"
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              // multiline={true}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            />
          </Field>
        </div>
      </div>
    )
  } else if (type === 'advanced') {
    return (
      <div className="FormFields">
        <div className="FormFields__column">
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-advanced-characters-label' version="v2" htmlFor="minMax">Number of Characters</FieldLabel>
            <div className="FormFields__group-fields">
              <TextInput
                type="number"
                version="v2"
                name={`${uniqueKey}.minimum`}
                value={schema.min || ''}
                onChange={onMinChange}
                min="0"
                error={schema.error && schema.error_details.min ? true : false}
                placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.min')}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_NUMBER_OF_CHARACTERS_INPUT)}
              />
              <span className="FormFields__group-separator">to</span>
              <TextInput
                type="number"
                version="v2"
                name={`${uniqueKey}.maximum`}
                value={schema.max || ''}
                onChange={onMaxChange}
                min="1"
                error={schema.error && schema.error_details.max ? true : false}
                placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.max')}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MAX_NUMBER_OF_CHARACTERS_INPUT)}
              />
            </div>
          </Field>
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-advanced-validation-label' version="v2" htmlFor="validationErrMsg">Validation Error Message</FieldLabel>
            <Help
              testId='cs-ctf-multilinetext-advanced-helptext'
              type="basic"
              text={
                props.t(
                  'global_field.content_type_edit.body.fields.multi_line.settings.advanced.validation_error_message.help_text'
                )
                  ? props.t(
                    'global_field.content_type_edit.body.fields.multi_line.settings.advanced.validation_error_message.help_text'
                  )
                  : 'Provide a custom error message to display if the validation checks specified in the Validation (Regex) field fails.'
              }
            />
            <TextInput
              name={`${uniqueKey}.validationErrMsg`}
              version="v2"
              value={schema.error_messages ? (schema.error_messages.format ? schema.error_messages.format : '') : ''}
              onChange={onValErrChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.VALIDATION_ERROR_MESSAGE_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-advanced-default-value-label' version="v2" htmlFor="defaultValue">Default Value</FieldLabel>
            <Help testId='cs-ctf-multilinetext-advanced-default-value-helptext' type="basic" text="Set a default field value for this field. The value will appear by default while creating an entry for this content type." />
            <TextInput
              name={`${uniqueKey}.defaultValue`}
              value={field_metadata.default_value || ''}
              version="v2"
              onChange={onDefaultValueChange}
              minLength={schema.min}
              maxLength={schema.max}
              error={schema.error && schema.error_details.default_value ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DEFAULT_VALUE_INPUT)}
            />
          </Field>
        </div>
        <div className="FormFields__column">
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-advanced-validation-label' version="v2" htmlFor="validation">Validation (Regex)</FieldLabel>
            <Help
              testId='cs-ctf-multilinetext-advanced-validation-helptext'
              type="basic"
              text={
                props.t(
                  'global_field.content_type_edit.body.fields.multi_line.settings.advanced.validation_regex.help_text'
                )
                  ? props.t(
                    'global_field.content_type_edit.body.fields.multi_line.settings.advanced.validation_regex.help_text'
                  )
                  : 'Define the validation for the field.'
              }
            />
            <TextInput
              name={`${uniqueKey}.validation`}
              version="v2"
              // value={field_metadata.format || ''}
              value={schema && schema.format ? schema.format : ''}
              onChange={onValChnage}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.VALIDATION_REGEX_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId='cs-ctf-multilinetext-advanced-options-label' version="v2" htmlFor="options">Options</FieldLabel>
            <div className="FormFields__selection-wrapper">
              <div className="ToggleWrap">
                <ToggleSwitch
                  testId={booleanTestIdFormatter("cs-ct-field-multiline-mandatory", schema.mandatory)}
                  name={`${uniqueKey}.mandatory`}
                  label="Mandatory"
                  checked={schema.mandatory}
                  onChange={onOptionsChange}
                />
              </div>
              {/* <Checkbox
                testId="cs-ct-field-multiline-mandatory"
                name={`${uniqueKey}.mandatory`}
                text="Mandatory"
                checked={schema.mandatory}
                onChange={onOptionsChange}
              /> */}
              {!options.singleton &&
                (parentInfo.hasParent
                  ? parentInfo.data_type == 'group' || parentInfo.data_type == 'global_field'
                  : true) ? (
                isCTBuilder ? (
                  <div className="ToggleWrap">
                    <ToggleSwitch
                      testId={booleanTestIdFormatter("cs-ct-field-multiline-unique", schema.unique)}
                      name={`${uniqueKey}.unique`}
                      label="Unique"
                      checked={schema.unique}
                      onChange={onOptionsChange}
                    />
                  </div>
                  // <Checkbox
                  //   testId="cs-ct-field-multiline-unique"
                  //   name={`${uniqueKey}.unique`}
                  //   text="Unique"
                  //   checked={schema.unique}
                  //   onChange={onOptionsChange}
                  // />
                ) : null
              ) : null}
              {/* <Checkbox
                testId="cs-ct-field-multiline-multiple"
                name={`${uniqueKey}.multiple`}
                text="Multiple"
                checked={schema.multiple}
                onChange={onOptionsChange}
              /> */}
              <div className="ToggleWrap">
                <ToggleSwitch
                  testId={booleanTestIdFormatter("cs-ct-field-multiline-multiple", schema.multiple)}
                  name={`${uniqueKey}.multiple`}
                  label="Multiple"
                  checked={schema.multiple}
                  onChange={onOptionsChange}
                />
              </div>
              {schema.multiple ? (
                <div className="FormFields__with-max-limit">
                  <Field>
                    <FieldLabel testId='cs-ct-field-multilinetext-advanced-maximum-limit-label' version="v2" className="ml-0" htmlFor="validation">
                      Set Maximum Limit
                    </FieldLabel>
                    <TextInput
                      type="number"
                      version="v2"
                      name={`${uniqueKey}.maxinstance`}
                      value={schema.max_instance || null}
                      onChange={onMaxInstance}
                      // placeholder="Maximum"
                      placeholder={props.t(
                        'content_type.save_content_type.body.fields.common_properties.placeholders.maximum'
                      )}
                      error={schema.error && schema.max_instance ? true : false}
                      testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}
                    />
                  </Field>
                </div>
              ) : null}
              {
                hasNonLocalizablePlan ? (
                  hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                    <NonLocalizableDom
                      isFieldPresent={true}
                      uniqueKey={uniqueKey}
                      schema={schema}
                      onOptionsChange={onOptionsChange}
                      dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-ct-field-multilinetext-non-localizable-parent-multiple` : `cs-ct-field-multilinetext-non-localizable`, schema.non_localizable)}
                      dataTestIdForDescription={"cs-ct-field-multiline-text-non-localizable-description"}
                      isNonLocalizable={isNonLocalizable}
                      isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                    />
                  ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                    <NonLocalizableDom
                      isFieldPresent={true}
                      uniqueKey={uniqueKey}
                      schema={schema}
                      onOptionsChange={onOptionsChange}
                      dataTestId={booleanTestIdFormatter("cs-ct-field-multilinetext-non-localizable", schema.non_localizable)}
                      dataTestIdForDescription={"cs-ct-field-multiline-text-non-localizable-description"}
                      isNonLocalizable={isNonLocalizable}
                      isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                    />

                    : null
                ) : null
              }
            </div>
          </Field>
          <GroupFieldTitleToggle
            parentInfo={parentInfo}
            uniqueKey={uniqueKey}
            field_metadata={field_metadata}
            onchange={onchange}
            multiple={schema?.multiple}
            testId="cs-ct-field-multilinetext-group-title"
          />
        </div>
      </div>
    )
  }
}

export default React.memo(MultiLineText)
